import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getFlooring } from '../features/flooring/flooringSlice'
import Spinner from '../components/Spinner'
import { sendPageView } from '../gtmUtils'

function Flooring() {
	const dispatch = useDispatch()

	const { flooring, isLoading, isSuccess } = useSelector((state) => state.flooring)

	useEffect(() => {
		sendPageView()
		dispatch(getFlooring())
	}, [dispatch])

	return (
		<>
			{isLoading || !isSuccess ? (
				<Spinner />
			) : (
				<div className='container'>
					<div className='flooring'>
						<h1 className='large'>Flooring</h1>
						<p>
							Specializing in many types of flooring installation including Hardwood, Laminate, and
							Luxury Vinyl Plank (LVP)
						</p>
						<br />

						<h2 className='large'>Previous Projects</h2>
						<h3>Hardwood</h3>
						<div className='projects-grid'>
							<h4>Removal of carpet and Hardwood flooring installation</h4>
							<br />
							<p>Before</p>
							<div className='project-grid'>
								{flooring.hardwood[0].before.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>

							<p>During</p>
							<div className='project-grid'>
								{flooring.hardwood[0].during.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>

							<p>After</p>
							<div className='project-grid'>
								{flooring.hardwood[0].after.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>

							<h4>
								Removal of carpet, built in shelving, drywall patching, painting and Hardwood
								flooring installation. Also, removal and installation of new baseboards and
								window/door trim.
							</h4>
							<br />
							<p>Before</p>
							<div className='project-grid'>
								{flooring.hardwood[1].before.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>

							<p>After</p>
							<div className='project-grid'>
								{flooring.hardwood[1].after.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>
						</div>

						<h3>Laminate</h3>
						<div className='projects-grid'>
							<h4>Installation of Laminate flooring</h4>
							<br />
							<p>After</p>
							<div className='project-grid'>
								{flooring.laminate[0].after.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>

							<h4>Installation of Laminate flooring as part of a basement finishing</h4>
							<br />
							<div className='project-grid'>
								{flooring.laminate[1].after.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>
						</div>

						<h3>Luxury Vinyl Plank (LVP)</h3>
						<div className='projects-grid'>
							<h4>Removal of carpet and flooring installation</h4>
							<div className='project-grid'>
								{flooring.vinyl[0].after.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>

							<h4>
								Removal of carpet, installation of flooring in whole basement. Painting of
								wainscotting and walls.
							</h4>
							<p>During</p>
							<div className='project-grid'>
								{flooring.vinyl[1].during.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>

							<p>After</p>
							<div className='project-grid'>
								{flooring.vinyl[1].after.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>

							<h4>Removal of carpet and flooring installation in 3 bedrooms</h4>
							<p>Bedroom 1</p>
							<div className='project-grid'>
								{flooring.vinyl[2].after.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>
							<p>Bedroom 2</p>
							<div className='project-grid'>
								{flooring.vinyl[3].after.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>
							<p>Bedroom 3</p>
							<div className='project-grid'>
								{flooring.vinyl[4].after.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>

							<p className='bg-primary'>Testimonial</p>
							<p>
								Paul recently installed new luxury vinyl plank flooring in 3 bedrooms at our
								cottage. He was professional, efficient, and the rooms look great.
							</p>
							<p>Thanks to Sproxton General Contracting for a job well done!!</p>
							<p>
								<strong>5 stars and we highly recommend!</strong>
							</p>
							<p>Ingrid & Howard</p>
							<br />
							<br />

							<h4>Installation of flooring in the hall and bedroom.</h4>
							<div className='project-grid'>
								{flooring.vinyl[5].after.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>

							<p className='bg-primary'>Testimonial from Bark.com</p>
							<p>
								We recently hired Paul to install vinyl flooring upstairs in our new home, and we
								couldn’t be happier with the experience. From start to finish, he was professional,
								communicative, and incredibly reliable.
							</p>
							<p>
								Paul provided honest pricing and straightforward advice, which made the whole
								process stress-free. The work was completed on time and with great
								precision—everything looks fantastic.
							</p>
							<p>
								We truly appreciate the care and attention he put into the job. We’ll absolutely be
								reaching out to Paul again for future projects and would highly recommend him to
								anyone looking for quality workmanship.
							</p>
							<p>Taylor H.</p>
							<br />
							<br />

							<h4>Installation of new flooring in an 850sqft basement.</h4>
							<div className='project-grid'>
								{flooring.vinyl[6].after.map((image, index) => (
									<div className='project-item' key={index}>
										<a href={image.full} target='_blank' rel='noreferrer'>
											<img src={image.thumbnail} alt={image.name} />
										</a>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default Flooring
